/* section-announcement-bar.js — extracted from sections/announcement-bar.liquid */
(function() {
    function initAnnouncementSequencer() {
      const viewports = document.querySelectorAll('.announcement-track-viewport');
      viewports.forEach(viewport => {
        const items = Array.from(viewport.querySelectorAll('.announcement-item'));
        if (items.length === 0) return;

        let currentIndex = 0;
        let timer = null;
        let isPaused = false;

        viewport.addEventListener('mouseenter', () => {
          isPaused = true;
          const activeItem = items[currentIndex];
          if (activeItem) activeItem.style.animationPlayState = 'paused';
        });

        viewport.addEventListener('mouseleave', () => {
          isPaused = false;
          const activeItem = items[currentIndex];
          if (activeItem) activeItem.style.animationPlayState = 'running';
        });

        function playItem(index) {
          if (timer) clearTimeout(timer);
          currentIndex = (index + items.length) % items.length;

          items.forEach(it => {
            it.classList.remove('is-active', 'is-exiting', 'anim--swipe_up', 'anim--swipe_down', 'anim--slide_left', 'anim--slide_right', 'anim--fade', 'anim--marquee_rtl', 'anim--marquee_ltr');
            it.style.animation = '';
            it.style.animationPlayState = '';
          });

          const currentItem = items[currentIndex];
          const anim = currentItem.getAttribute('data-animation') || 'swipe_up';
          const durationSec = parseFloat(currentItem.getAttribute('data-duration')) || 4;
          const durationMs = durationSec * 1000;

          currentItem.classList.add(`anim--${anim}`);
          currentItem.classList.add('is-active');

          if (items.length === 1 && (anim === 'marquee_rtl' || anim === 'marquee_ltr')) {
            currentItem.style.animationDuration = `${durationSec}s`;
            return; // Single marquee item loops continuously
          }

          if (anim === 'marquee_rtl' || anim === 'marquee_ltr') {
            currentItem.style.animationDuration = `${durationSec}s`;
            currentItem.style.animationIterationCount = '1';

            timer = setTimeout(() => {
              proceedToNext();
            }, durationMs);
          } else {
            timer = setTimeout(() => {
              if (items.length > 1) {
                currentItem.classList.add('is-exiting');
                setTimeout(() => {
                  proceedToNext();
                }, 400);
              }
            }, durationMs);
          }
        }

        function proceedToNext() {
          if (isPaused) {
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
            const checkInterval = setInterval(() => {
              if (!isPaused) {
                clearInterval(checkInterval);
                playItem(currentIndex + 1);
              }
            }, 500);
          } else {
            playItem(currentIndex + 1);
          }
        }

        // Start initial playback
        playItem(0);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAnnouncementSequencer);
      document.addEventListener('shopify:section:load', initAnnouncementSequencer);
      if (document.readyState !== 'loading') initAnnouncementSequencer();
    } else {
      initAnnouncementSequencer();
    }
  })();
